"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

/**
 * @module ol/Kinetic
 */

/**
 * @classdesc
 * Implementation of inertial deceleration for map movement.
 *
 * @api
 */
var Kinetic =
/** @class */
function () {
  /**
   * @param {number} decay Rate of decay (must be negative).
   * @param {number} minVelocity Minimum velocity (pixels/millisecond).
   * @param {number} delay Delay to consider to calculate the kinetic
   *     initial values (milliseconds).
   */
  function Kinetic(decay, minVelocity, delay) {
    /**
     * @private
     * @type {number}
     */
    this.decay_ = decay;
    /**
     * @private
     * @type {number}
     */

    this.minVelocity_ = minVelocity;
    /**
     * @private
     * @type {number}
     */

    this.delay_ = delay;
    /**
     * @private
     * @type {Array<number>}
     */

    this.points_ = [];
    /**
     * @private
     * @type {number}
     */

    this.angle_ = 0;
    /**
     * @private
     * @type {number}
     */

    this.initialVelocity_ = 0;
  }
  /**
   * FIXME empty description for jsdoc
   */


  Kinetic.prototype.begin = function () {
    this.points_.length = 0;
    this.angle_ = 0;
    this.initialVelocity_ = 0;
  };
  /**
   * @param {number} x X.
   * @param {number} y Y.
   */


  Kinetic.prototype.update = function (x, y) {
    this.points_.push(x, y, Date.now());
  };
  /**
   * @return {boolean} Whether we should do kinetic animation.
   */


  Kinetic.prototype.end = function () {
    if (this.points_.length < 6) {
      // at least 2 points are required (i.e. there must be at least 6 elements
      // in the array)
      return false;
    }

    var delay = Date.now() - this.delay_;
    var lastIndex = this.points_.length - 3;

    if (this.points_[lastIndex + 2] < delay) {
      // the last tracked point is too old, which means that the user stopped
      // panning before releasing the map
      return false;
    } // get the first point which still falls into the delay time


    var firstIndex = lastIndex - 3;

    while (firstIndex > 0 && this.points_[firstIndex + 2] > delay) {
      firstIndex -= 3;
    }

    var duration = this.points_[lastIndex + 2] - this.points_[firstIndex + 2]; // we don't want a duration of 0 (divide by zero)
    // we also make sure the user panned for a duration of at least one frame
    // (1/60s) to compute sane displacement values

    if (duration < 1000 / 60) {
      return false;
    }

    var dx = this.points_[lastIndex] - this.points_[firstIndex];
    var dy = this.points_[lastIndex + 1] - this.points_[firstIndex + 1];
    this.angle_ = Math.atan2(dy, dx);
    this.initialVelocity_ = Math.sqrt(dx * dx + dy * dy) / duration;
    return this.initialVelocity_ > this.minVelocity_;
  };
  /**
   * @return {number} Total distance travelled (pixels).
   */


  Kinetic.prototype.getDistance = function () {
    return (this.minVelocity_ - this.initialVelocity_) / this.decay_;
  };
  /**
   * @return {number} Angle of the kinetic panning animation (radians).
   */


  Kinetic.prototype.getAngle = function () {
    return this.angle_;
  };

  return Kinetic;
}();

var _default = Kinetic;
exports["default"] = _default;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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